import React, { useState } from "react";
import clsx from "clsx";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Typography from "../Typography";
import ITransferPhasebar from "./TransferPhasebar";
import { MHWhiteLogo } from "../../../assets/Icons";
import Modal from "../Modal";
import Checkbox from "../Checkbox";
import Button from "../Button";

export const TransferPhasebar: React.FC<ITransferPhasebar.IProps> = ({
  data,
  activeStepNumber,
  transactionMode,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState<string>("");
  const [cancellationReasons, setCancellationReasons] = useState<string>("");
  const [otherReason, setOtherReason] = useState<string>("");
  const TransactioncancellationReasons = [
    "Do not have documents yet",
    "Just trying the platform",
    "Connectivity issue",
    "Other Reason...",
  ];

  return (
    <div className="flex flex-col items-center bg-primary-1050 h-full md:min-w-[379px] pt-24 pb-[92px] fixed z-50">
      <div className="flex flex-col items-center">
        <div onClick={() => setIsModalOpen("cancelReasons")} className="pb-[73px] cursor-pointer">
          <MHWhiteLogo />
        </div>
        {transactionMode && (
          <div className="-mt-10 text-white text-[20px] font-bold">
            {transactionMode === "Offline"
              ? "moneyHOP Offline"
              : transactionMode === "WesternUnion"
              ? "Western Union Offline"
              : transactionMode === "Flywire"
              ? "Flywire Offline"
              : ""}
          </div>
        )}
        <ul role="list" className="mt-20">
          {data.map((value, index) => (
            <li key={index}>
              <div className="relative mb-[66px]">
                {index !== data.length - 1 ? (
                  <span
                    className={clsx(
                      value.id < activeStepNumber ? "bg-[#FF820E]" : "bg-primary-1100",
                      "absolute top-10 left-4 h-[66px] w-0.5",
                    )}
                    aria-hidden="true"
                  />
                ) : null}
                <div className="relative flex items-center">
                  <div
                    className={clsx(
                      value.id <= activeStepNumber ? "bg-[#FF820E]" : "bg-white",
                      "h-10 w-9 rounded-full flex items-center justify-center mr-7",
                    )}
                  >
                    <Typography
                      tagType="div"
                      text={value.id}
                      className={clsx(
                        value.id <= activeStepNumber ? "text-white" : "text-primary-1050",
                        "font-medium text-xl",
                      )}
                    />
                  </div>
                  <Link to={value?.id <= activeStepNumber ? value.pathName : location?.pathname}>
                    <div
                      className={clsx(
                        value?.id <= activeStepNumber ? "cursor-pointer" : "cursor-not-allowed",
                        "text-xl font-medium text-white hover:scale-110 transition-all",
                      )}
                    >
                      {value.phaseName}
                    </div>
                  </Link>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <Modal
        header="Cancel Transaction"
        headerClass={"text-white"}
        modalClass="!p-0 rounded lg:overflow-hidden overflow-y-scroll max-h-[90%] lg:max-h-full"
        visible={isModalOpen === "cancelReasons"}
        closeHandler={() => setIsModalOpen("")}
        closable={false}
      >
        <div className="flex flex-col items-center px-5 py-10 space-y-6">
          <span className="font-ssp text-[18px] ">
            Are you sure you want to cancel the transaction?
          </span>
          <div className="flex justify-center w-full space-x-5">
            <button
              onClick={() => navigate("/home")}
              className="w-1/4 px-6 py-2 font-bold text-white transition-all rounded-full bg-primary hover:bg-primary-650 hover:scale-105 font-ssp"
            >
              Yes
            </button>
            <button
              onClick={() => setIsModalOpen("")}
              className="w-1/4 px-6 py-2 font-bold text-white transition-all rounded-full bg-primary hover:bg-primary-650 hover:scale-105 font-ssp"
            >
              No
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        header="Reason for cancellation"
        headerClass={"bg-white !my-0 py-6 px-12 font-bold text-lg"}
        modalClass="!p-0 !rounded !overflow-hidden lg:mb-20 !w-full lg:!w-auto"
        visible={isModalOpen === "oldModal"}
        closeHandler={() => setIsModalOpen("")}
        closable={false}
      >
        <div className="px-5 pb-5">
          {TransactioncancellationReasons.map((data, index) => {
            return (
              <div className="space-x-2 px-7 border-b-[1px] py-6 first:pt-0" key={index}>
                <Checkbox
                  label={data}
                  value={data}
                  name={"cancellationReason"}
                  handleChange={(e) => {
                    setCancellationReasons(e.target.value);
                  }}
                  checkboxClassname="!mr-4"
                />
              </div>
            );
          })}
          {cancellationReasons === "Other Reason..." && (
            <div className="flex items-center justify-center mt-2">
              <textarea
                name="otherReasonDescription"
                value={otherReason}
                rows={4}
                cols={50}
                placeholder="Write your reason here....."
                onChange={(e) => {
                  setOtherReason(e.target.value);
                }}
                className="w-full p-3 bg-white-100 focus-visible:border-0 placeholder:text-center"
              />
            </div>
          )}
          <div className="flex items-center justify-center mt-7 px-[78px]">
            <Button
              bgColor={`${cancellationReasons === "" ? "bg-grey-350" : "bg-primary"}`}
              fontStyle={{
                fontFamily: "",
                fontSize: "text-lg",
                fontWeight: "font-bold",
                fontColor: "text-white",
              }}
              borderStyle={{
                borderWidth: "border-none",
                borderRadius: "rounded-[100px]",
              }}
              disabled={cancellationReasons === ""}
              className={"py-3 px-28"}
              onClickHandler={() =>
                cancellationReasons !== "" && cancellationReasons === "Other Reason..."
                  ? otherReason !== "" && navigate("/")
                  : navigate("/")
              }
            >
              Submit
            </Button>
          </div>
        </div>
      </Modal>
      {/* <div className="mx-auto w-[318px] py-2 flex items-center justify-center text-primary-1050 bg-white cursor-pointer">
        <a
          className="font-medium text-[18px]"
          href="https://www.moneyhop.co/contact/"
        >
          Need Help? Contact moneyHop Support
        </a>
      </div> */}
    </div>
  );
};
